export default class VZConfirmationModal {
    constructor() {
        if (window.bs && window.bs.Modal) {
            this.confirmationModal = new window.bs.Modal(document.getElementById('confirmation-modal'));
        }

        this.toggleConfirmationModal = this.toggleConfirmationModal.bind(this);
    }

    toggleConfirmationModal() {
        if (!this.confirmationModal) {
            return Promise.reject(new Error('Confirmation modal is not initialized.'));
        }

        this.confirmationModal.show();

        return new Promise((resolve) => {
            const handleCancel = () => {
                cleanup(); // eslint-disable-line no-use-before-define
                resolve(false);
            };

            const handleConfirm = () => {
                cleanup(); // eslint-disable-line no-use-before-define
                resolve(true);
            };

            const cleanup = () => {
                this.confirmationModal._element.querySelector('.js-confirmation-modal-cancel').removeEventListener('click', handleCancel); // eslint-disable-line no-underscore-dangle
                this.confirmationModal._element.querySelector('.js-confirmation-modal-confirm').removeEventListener('click', handleConfirm); // eslint-disable-line no-underscore-dangle
            };

            this.confirmationModal._element.querySelector('.js-confirmation-modal-cancel').addEventListener('click', handleCancel); // eslint-disable-line no-underscore-dangle
            this.confirmationModal._element.querySelector('.js-confirmation-modal-confirm').addEventListener('click', handleConfirm); // eslint-disable-line no-underscore-dangle
        });
    }
}
